import React, {useRef} from 'react';
import {Link} from 'react-router-dom';
import routes from 'globals/routes';
import { useDataValue } from 'globals/contexts/dataContext';
import './footer.css';
import './footerMobile.css';
import ContactBlock from './contactBlock';
const Footer = () => {
  const [{content, currentLanguage}, _] = useDataValue();
  const socialMedia = content['content'][currentLanguage]['socialLink'];
  const inputWrapper = useRef();
  const setFocus = () => {
    inputWrapper.current.classList.add("focus");
  }
  const setBlur = () => {
    inputWrapper.current.classList.remove("focus");
  }
  const checkFilled = (e) => {
    const inputedEmail = e.currentTarget.value.trim();
    if (inputedEmail !== "") {
      inputWrapper.current.classList.add("filled");
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(String(inputedEmail).toLowerCase())) {
        inputWrapper.current.classList.add("correct");
      } else {
        inputWrapper.current.classList.remove("correct");
      }
    } else {
      inputWrapper.current.classList.remove("filled");
      inputWrapper.current.classList.remove("correct");
    }
  }
  return (
    <section className="footer" id="footer">
      <div className="infoBlock">
        <img className="logo" src={content['logo']} />
        {/* <div className="links">
          <a className="link" href="#">About Us</a>
          <a className="link" href="#">Art</a>
          <a className="link" href="#">Experience</a>
          <a className="link" href="#">Products</a>
          <a className="link" href="#">Partnerships</a>
          <a className="link" href="#">Commercial</a>
        </div> */}
        <ContactBlock />
      </div>
      <div className="socialMediaBlock">
        <div className="title">{(currentLanguage === 'tc'? '關注我們': 'Follow Us')}</div>
        <div className="socialMedia">
          {socialMedia.map(medium => {
            return <div key={medium['type']} className={`media ${medium['type']}`}>
              <a href={medium['url']} target="_blank">
                <img src={`./media/${medium['type']}.png`} />
              </a>
            </div>
          })}
        </div>
      </div>
      <div className="subscribeBlock">
        {/* <div className="label">Subscribe To Our E-Newsletter</div>
        <div className="inputField" ref={inputWrapper}>
          <input type="email" onFocus={setFocus} onBlur={setBlur} onInput={checkFilled} />
          <div className="placeholder">Type Your Email Here</div>
        </div>
        <div className="button">Subscribe</div> */}
      </div>
    </section>
  );
}

export default Footer;